// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { FullRescanStepSchema } from './FullRescanStepSchema'
import type { FullRescanStep } from './FullRescanStepSchema'
import { FullRescanBaselineFindingSchema } from './FullRescanBaselineFindingSchema'
import type { FullRescanBaselineFinding } from './FullRescanBaselineFindingSchema'
import { FullRescanRunSchema } from './FullRescanRunSchema';

/////////////////////////////////////////
// FULL RESCAN RUN RELATION SCHEMA
/////////////////////////////////////////

export type FullRescanRunRelations = {
  application: ApplicationWithRelations;
  steps: FullRescanStep[];
  baselineFindings: FullRescanBaselineFinding[];
};

export type FullRescanRunWithRelations = z.infer<typeof FullRescanRunSchema> & FullRescanRunRelations

export const FullRescanRunWithRelationsSchema: z.ZodType<FullRescanRunWithRelations> = FullRescanRunSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
  steps: z.lazy(() => FullRescanStepSchema).array(),
  baselineFindings: z.lazy(() => FullRescanBaselineFindingSchema).array(),
}))